import React from 'react';
import { Button, Grid, Typography } from '@material-ui/core';

import CustomAccordion from '../../../shared/components/CustomAccordion';
import { StatusResult } from '../../../shared/enum/StatusResult';
import { useResultStyles } from '../../../shared/components/UploadStyles';
import SucessImg from '../../../assets/sucess.svg';
import ErrorImg from '../../../assets/error.svg';
import { UploadStilingueResultProps } from '../../../Models/UploadStilingueResultPropsModel';

interface IStilingueSpreadsheetUploadResultProps {
    result: UploadStilingueResultProps,
    nameFile: string,
    onClickNewUpload: () => void,
}

export function StilingueSpreadsheetUploadResult({ result, nameFile, onClickNewUpload }: IStilingueSpreadsheetUploadResultProps) {
    const classes = useResultStyles();

    function getTitle(): string {
        if (result.status == StatusResult.ERROR) {
            if (result.property == 'SpreadsheetAccess' || result.property == 'SpreadsheetFile')
                return 'Não foi possível acessar a planilha inserida.';

            return 'Ocorreu um problema com o processamento da sua planilha.';
        } else {
            return 'Sua planilha foi processada com sucesso!';
        }
    }

    function getSubTitle(): string {
        if (result.status == StatusResult.ERROR) {
            switch (result.property) {
            case 'SpreadsheetAccess':
                return 'Não foi possível abrir a planilha inserida para realizar o processamento de dados. Por gentiliza, revise a planilha e realize um novo upload.';
            case 'SpreadsheetFile':
                return 'Não foi possível abrir a planilha inserida para realizar o processamento de dados. Por gentiliza, revise a extensão do arquivo.';
            case 'StilingueSpreadsheetModelConfig':
                return 'Não foi possível localizar nenhuma configuração de planilha salva para o modelo selecionado.';
            case 'SpreadsheetUploadException':
                return 'Não foi possível realizar o upload da planilha para o Storage da Azure.';
            default:
                return 'Não conseguimos processar alguns campos da sua planilha. Por gentiliza, revise a planilha e realize um novo upload.';
            }
        } else {
            return 'Tudo pronto! Todas as publicações foram importadas!';
        }
    }

    const getTitleAndSubtitle = () => {
        return (
            <>
                <Grid item>
                    <Typography variant="h4" className={classes.title}>
                        {getTitle()}
                    </Typography>
                </Grid>
                <Grid item>
                    <Typography variant="body1" className={classes.item}>
                        {getSubTitle()}
                    </Typography>
                </Grid>
            </>
        );
    };

    function getIcon() {
        if (result.status == StatusResult.ERROR) {
            return (
                <div className={classes.icon}>
                    <img src={ErrorImg} alt="" />
                </div>
            );
        } else {
            return (
                <div className={classes.icon}>
                    <img src={SucessImg} alt="" />
                </div>
            );
        }
    }

    return (
        <Grid
            container
            direction="column"
            justify="center"
            alignItems="center">
            
            { getTitleAndSubtitle() }
            {(result.status == StatusResult.ERROR) && (
                <div className={classes.item}>
                    <CustomAccordion messages={result.message} title={result.title} />
                </div>
            )}
            { getIcon() }
            <Typography variant="subtitle1" className={classes.nameFile}>
                {nameFile}
            </Typography>
            <Button
                size="large"
                variant="outlined"
                className={classes.button}
                onClick={onClickNewUpload}>
                FAZER UPLOAD DE NOVA PLANILHA
            </Button>
        </Grid>
    );
}